<template>
  <div
    class="app-list"
    @click="
      $router.push({
        name: 'archiveDetail',
        query: { detailId: archive.resourceId },
      })
    "
  >
    <div class="left">
      <!-- <img src="../assets/img/ext-ppt.png" alt="" /> -->
      {{ archive.name }}
    </div>
    <div class="right">
      <img class="icon-user" src="../assets/img/icon-user.png" alt="" />
      作者姓名：<span>{{ archive.author }}</span>
      <el-divider direction="vertical"></el-divider>
      <img class="icon-clock" src="../assets/img/icon-clock.png" alt="" />
      上传时间：{{ archive.createTime }}
      <el-divider direction="vertical"></el-divider>
      <img class="icon-detail" src="../assets/img/icon-detail.png" alt="" />
      {{ archive.viewCount }}
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    archive: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},
};
</script>
<style scoped lang="less">
.app-list {
  cursor: pointer;
  display: flex;
  height: 80px;
  background: linear-gradient(180deg, #f8faff 0%, #ffffff 100%);
  box-shadow: 0px 2px 20px 0px rgba(119, 135, 182, 0.17);
  border: 2px solid;
  border-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1),
      rgba(247, 248, 251, 0)
    )
    2 2;
  margin-bottom: 20px;
  padding: 20px;
  box-sizing: border-box;
  .left {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 36px;
  }
  .right {
    margin-left: 20px;
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #595959;
    line-height: 20px;
    .icon-user {
      position: relative;
      top: 2px;
    }
    .icon-clock {
      position: relative;
      top: 8px;
    }
    .icon-detail {
      position: relative;
      top: 1px;
    }
  }
}
</style>